import { queryOptions } from "@tanstack/react-query";
import axios from "axios";
import { createQueryGroup } from "../../core/api/queries";
import { auth } from "../../core/auth";
import { env } from "../../env";
import { PdfFormTemplateId } from "../../shared/schema/schema";

export default createQueryGroup(({ api }) => ({
  list: () =>
    queryOptions({
      queryKey: ["pdf-form-templates"],
      queryFn: () => api.get("./pdf_form_templates", {}),
      select: ({ templates }) => templates,
    }),

  get: (templateId: PdfFormTemplateId) =>
    queryOptions({
      queryKey: ["pdf-form-templates", templateId],
      queryFn: () =>
        api.get("./pdf_form_templates/:pdfFormTemplateId", {
          path: { pdfFormTemplateId: templateId },
        }),
    }),

  // PDF bytes come through the server proxy (S3 CORS-free); cached forever
  // per template because the file never changes.
  file: (templateId: PdfFormTemplateId) =>
    queryOptions({
      queryKey: ["pdf-form-templates", templateId, "file"],
      queryFn: async () => {
        const authState = auth.getAuthOrFail();
        const response = await axios.get<ArrayBuffer>(
          `${env.API_URL}agencies/${authState.data.agency.id}/agency_members/${authState.data.agencyMember.id}/pdf_form_templates/${templateId}/file`,
          {
            headers: { Authorization: `Token ${authState.tokens.authToken}` },
            responseType: "arraybuffer",
          }
        );
        return response.data;
      },
      staleTime: Infinity,
    }),
}));
